import { Component } from '@angular/core'
import { FileDataService, TaskProcessing, FileUpload } from './commons/file-data.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Project, Account } from '4d-mapper'
import { Subscription, combineLatest } from 'rxjs'
import { Location } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { LoadingSpinner } from '../commons/ui/loading-spinner'

@Component({
    selector:'app-root-comp',
    templateUrl:'./app.component.html',
    styleUrls:['./app.component.scss']

})
export class AppBaseComponent{

    projects:Project[] = []
    team:Account
    teams:Account[] = []

    processing:TaskProcessing[] = []
    uploads:FileUpload[] = []
   
    private _subs:Subscription[] = []

    constructor(private fileManager:FileDataService,  private route:ActivatedRoute, private router:Router, private location:Location, public translate: TranslateService ) {
  
    }
  
    ngOnInit(){

        LoadingSpinner.end();
  
      this.fileManager.init().subscribe()

      combineLatest(this.fileManager.onReady(),this.route.params).subscribe(([_,params]) => {
          console.log('TEAMS',params);
        // listen to param changes
        if(params.team){
            var team = this.fileManager.teams.values.find(t => t.uid == params.team)
            if(team)
                // this will trigger everyone else
                this.fileManager.initTeam(team).subscribe()
            else
                throw new Error("Invalid team for this account " + params.team)
        }
    
      })
      
      this._subs.push(this.fileManager.processingItems.state.subscribe(s => this.processing = s))
      this._subs.push(this.fileManager.uploadingFiles.state.subscribe(s => this.uploads = s))
      this._subs.push(this.fileManager.uploadingQueue.state.subscribe(s => this.uploads = s))
      
      this._subs.push(this.fileManager.projects.state.subscribe(s => this.projects = s))
      this._subs.push(this.fileManager.teams.state.subscribe(s => this.teams = s))
      this._subs.push(this.fileManager.team.events.subscribe(s => {
          if(s.event == 'ADD'){
            this.team = s.item
            var path = this.router.url
            if(path.indexOf('?') != -1) path= path .substring(0,path.indexOf('?'))
            var v = path.split('/')
            v[0] = '/' + v[0]

            // if teams changed, redirect to same place on new team
            if(v[2] != s.item.uid){
                v[2] = s.item.uid
                this.router.navigate(v)
            }
            
          }
          else if(s.event == 'REMOVE'){
              this.team = null
          }
      }))
        
    }  


    ngOnDestroy(){
        this._subs.forEach(s => s.unsubscribe())
    }
  
    setTeam(uid:string){
        this.fileManager.initTeam(this.fileManager.teams.values.find(t => t.uid == uid)).subscribe()
    }
    goto(url:string[]){
        this.router.navigate(url,{relativeTo:this.route})
    }
}

@Component({
    selector:'home-comp',
    template:`<div class="p5 text-center">
        <h3>Hello placeholder</h3>
        <a [routerLink]="['..','files','folder','root']">Files</a> |  <a [routerLink]="['..','project']">Projects</a>
        </div>
    ` 
})
export class HomeComponent{
    
}